
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const RestorationPage = () => {
  const [selectedComparison, setSelectedComparison] = useState(0);
  const [sliderPosition, setSliderPosition] = useState(50);

  const restorationProjects = [
    {
      id: 1,
      title: '自由之家主建築修復',
      year: '2023-2024',
      description: '恢復建築原有的歷史風貌，加強結構安全，保留歷史文化價值。',
      beforeImage: 'https://public.readdy.ai/ai/img_res/b9dd9b7c02d590a1016e0861c0ffa9e4.jpg',
      afterImage: 'https://readdy.ai/api/search-image?query=Beautifully%20restored%20traditional%20Chinese%20government%20building%2C%20pristine%20white%20walls%2C%20renovated%20wooden%20structures%2C%20preserved%20historical%20architecture%2C%20elegant%201950s%20style%20building%20with%20traditional%20elements%2C%20perfect%20condition&width=800&height=600&seq=after1&orientation=landscape',
      highlights: ['結構加固', '外牆修復', '屋頂翻新', '門窗更換']
    },
    {
      id: 2,
      title: '大同官邸庭園景觀',
      year: '2022-2023',
      description: '重現官邸庭園的原始設計，結合現代景觀技術與傳統造園理念。',
      beforeImage: 'https://readdy.ai/api/search-image?query=Overgrown%20traditional%20Chinese%20garden%20before%20restoration%2C%20wild%20vegetation%2C%20neglected%20pathways%2C%20old%20stone%20features%20covered%20by%20plants%2C%20abandoned%20historical%20garden%20landscape&width=800&height=600&seq=before2&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Perfectly%20manicured%20traditional%20Chinese%20garden%20after%20restoration%2C%20neat%20pathways%2C%20beautiful%20stone%20features%2C%20well-maintained%20plants%20and%20trees%2C%20serene%20historical%20garden%20landscape%20with%20traditional%20elements&width=800&height=600&seq=after2&orientation=landscape',
      highlights: ['庭園設計', '植栽規劃', '步道修建', '水景復原']
    },
    {
      id: 3,
      title: '歷史文物展示空間',
      year: '2024',
      description: '打造專業的文物展示環境，確保珍貴歷史資料的妥善保存與展示。',
      beforeImage: 'https://readdy.ai/api/search-image?query=Empty%20old%20room%20before%20museum%20conversion%2C%20bare%20walls%2C%20outdated%20lighting%2C%20simple%20wooden%20floors%2C%20basic%20interior%20space%20needing%20renovation%20for%20historical%20display&width=800&height=600&seq=before3&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Modern%20museum%20exhibition%20space%20after%20renovation%2C%20professional%20display%20cases%2C%20elegant%20lighting%2C%20polished%20floors%2C%20sophisticated%20interior%20design%20for%20historical%20artifacts%20display&width=800&height=600&seq=after3&orientation=landscape',
      highlights: ['展示櫃設計', '照明系統', '溫濕度控制', '安全防護']
    },
    {
      id: 4,
      title: '辦公室歷史場景重現',
      year: '2023',
      description: '重現嚴家淦總統辦公時期的歷史場景，讓參觀者感受當年的工作環境。',
      beforeImage: 'https://readdy.ai/api/search-image?query=Old%20government%20office%20before%20historical%20recreation%2C%20empty%20room%20with%20basic%20furniture%2C%20outdated%20decor%2C%20simple%20desk%20and%20chairs%2C%20plain%20interior%20waiting%20for%20historical%20restoration&width=800&height=600&seq=before4&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Historically%20accurate%201970s%20presidential%20office%20recreation%2C%20vintage%20wooden%20desk%2C%20period-appropriate%20furniture%2C%20traditional%20Chinese%20decorations%2C%20authentic%20historical%20atmosphere%20with%20warm%20lighting&width=800&height=600&seq=after4&orientation=landscape',
      highlights: ['家具復原', '歷史陳設', '文件展示', '氛圍營造']
    },
    {
      id: 5,
      title: '會客廳文化空間',
      year: '2024',
      description: '修復傳統會客廳，結合茶文化體驗，打造文化交流的溫馨空間。',
      beforeImage: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20reception%20room%20before%20restoration%2C%20worn%20furniture%2C%20faded%20decorations%2C%20old%20carpet%2C%20simple%20interior%20needing%20cultural%20renovation%20and%20tea%20ceremony%20setup&width=800&height=600&seq=before5&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20reception%20room%20after%20restoration%2C%20beautiful%20wooden%20furniture%2C%20tea%20ceremony%20setup%2C%20refined%20decorations%2C%20warm%20cultural%20atmosphere%20perfect%20for%20traditional%20gatherings&width=800&height=600&seq=after5&orientation=landscape',
      highlights: ['傳統家具', '茶席設置', '文化裝飾', '空間規劃']
    }
  ];

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSliderPosition(parseInt(e.target.value));
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-amber-50 to-stone-100">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold text-stone-800 mb-6">
              故居修復計畫
            </h1>
            <p className="text-xl text-stone-600 mb-8">
              百年古蹟的重生之路，傳承歷史文化的珍貴記憶
            </p>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg">
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-amber-600 mb-2">
                    <i className="ri-building-line text-3xl"></i>
                  </div>
                  <h3 className="font-semibold text-stone-800 mb-1">修復項目</h3>
                  <p className="text-2xl font-bold text-amber-600">5個</p>
                </div>
                <div>
                  <div className="text-amber-600 mb-2">
                    <i className="ri-calendar-check-line text-3xl"></i>
                  </div>
                  <h3 className="font-semibold text-stone-800 mb-1">修復期間</h3>
                  <p className="text-2xl font-bold text-amber-600">2022-2024</p>
                </div>
                <div>
                  <div className="text-amber-600 mb-2">
                    <i className="ri-award-line text-3xl"></i>
                  </div>
                  <h3 className="font-semibold text-stone-800 mb-1">文化價值</h3>
                  <p className="text-2xl font-bold text-amber-600">無價</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Navigation */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-4">
            {restorationProjects.map((project, index) => (
              <button
                key={project.id}
                onClick={() => setSelectedComparison(index)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                  selectedComparison === index
                    ? 'bg-amber-600 text-white shadow-lg'
                    : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
                }`}
              >
                {project.title}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Before/After Comparison */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-stone-800 mb-4">
                {restorationProjects[selectedComparison].title}
              </h2>
              <p className="text-xl text-stone-600 mb-2">
                修復年份：{restorationProjects[selectedComparison].year}
              </p>
              <p className="text-lg text-stone-600 max-w-3xl mx-auto">
                {restorationProjects[selectedComparison].description}
              </p>
            </div>

            {/* Image Comparison Slider */}
            <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden mb-12">
              <div className="relative aspect-[4/3] overflow-hidden">
                {/* Before Image */}
                <img
                  src={restorationProjects[selectedComparison].beforeImage}
                  alt="修復前"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                
                {/* After Image with clip */}
                <div 
                  className="absolute inset-0 overflow-hidden"
                  style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
                >
                  <img
                    src={restorationProjects[selectedComparison].afterImage}
                    alt="修復後"
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Slider Line */}
                <div 
                  className="absolute top-0 bottom-0 w-1 bg-white shadow-lg z-10"
                  style={{ left: `${sliderPosition}%` }}
                >
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center">
                    <i className="ri-drag-move-line text-stone-600"></i>
                  </div>
                </div>

                {/* Labels */}
                <div className="absolute top-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-medium">
                  修復前
                </div>
                <div className="absolute top-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-medium">
                  修復後
                </div>
              </div>

              {/* Slider Control */}
              <div className="p-6">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={sliderPosition}
                  onChange={handleSliderChange}
                  className="w-full h-2 bg-stone-200 rounded-lg appearance-none cursor-pointer slider"
                />
                <div className="flex justify-between text-sm text-stone-500 mt-2">
                  <span>修復前</span>
                  <span>拖動查看對比</span>
                  <span>修復後</span>
                </div>
              </div>
            </div>

            {/* Project Highlights */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-stone-800 mb-6 text-center">修復重點</h3>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                {restorationProjects[selectedComparison].highlights.map((highlight, index) => (
                  <div key={index} className="text-center">
                    <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-check-line text-2xl text-amber-600"></i>
                    </div>
                    <h4 className="font-semibold text-stone-800">{highlight}</h4>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Restoration Process */}
      <section className="py-20 bg-stone-100">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-stone-800 text-center mb-16">修復流程</h2>
            
            <div className="space-y-8">
              {[
                {
                  step: '01',
                  title: '歷史調研',
                  description: '深入研究歷史資料，了解建築原貌與文化背景',
                  icon: 'ri-search-line'
                },
                {
                  step: '02',
                  title: '現況評估',
                  description: '專業團隊評估建築結構與保存狀況',
                  icon: 'ri-eye-line'
                },
                {
                  step: '03',
                  title: '修復設計',
                  description: '制定詳細的修復計畫與施工方案',
                  icon: 'ri-draft-line'
                },
                {
                  step: '04',
                  title: '精工修復',
                  description: '運用傳統工藝與現代技術進行修復',
                  icon: 'ri-hammer-line'
                },
                {
                  step: '05',
                  title: '品質驗收',
                  description: '嚴格檢驗修復成果，確保歷史價值保存',
                  icon: 'ri-shield-check-line'
                }
              ].map((process, index) => (
                <div key={index} className="flex items-center bg-white rounded-2xl p-8 shadow-lg">
                  <div className="flex-shrink-0 w-20 h-20 bg-amber-600 text-white rounded-full flex items-center justify-center mr-8">
                    <span className="text-2xl font-bold">{process.step}</span>
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-2xl font-bold text-stone-800 mb-2 flex items-center">
                      <i className={`${process.icon} text-amber-600 mr-3`}></i>
                      {process.title}
                    </h3>
                    <p className="text-stone-600 text-lg">{process.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RestorationPage;
